import script from "./LoadBackgroundModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadBackgroundModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadBackgroundModal.vue?vue&type=style&index=0&id=00a563cc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a563cc"]])

export default __exports__